import axios from 'axios';
import { API, TELEPHONE_CODE, URLS, IGNORE_ERROR_NOTIFY_URL } from 'config';
import { push } from 'react-router-redux';

import { notify } from 'react-notify-toast';

import { progressFile } from 'pages/Upload/actions';
import { logout, saveUser } from 'pages/Login/actions';
import { store } from '../index';

let AdminToken = {};

export const setToken = (token) => {
  if (token) {
    axios.defaults.headers.common.token = `${token}`;
    localStorage.setItem('carsapp-x-access-token', token);
  } else {
    delete axios.defaults.headers.common.token;
    localStorage.removeItem('carsapp-x-access-token');
    // localStorage.removeItem('carsapp');
  }
};
export const setTokenAdmin = (resivedToken) => {
  if (resivedToken) {
    AdminToken = {
      token: resivedToken
    };
    localStorage.setItem('carsapp-x-access-token-admin', resivedToken);
  } else {
    AdminToken = {};
    localStorage.removeItem('carsapp-x-access-token-admin');
    // localStorage.removeItem('carsapp');
  }
};

const importantUrls = [API.SIGN_UP_CODE_ACTIVATION,
  API.BIRTHDAY_ADD, API.GENDER, API.WORKING, API.DOWNPAYMENTS,
  API.EXPERIENCE, API.MOUNTHLY, API.CONFIRMATION, API.NAME, API.EMAIL];

const requestWrapper = func => new Promise((resolve, reject) => func
  .then((response) => {
    if (importantUrls.findIndex(el => response.config.url === el) > -1) {
      if (response.config.url === API.SIGN_UP_CODE_ACTIVATION && response.data.user) {
        store.dispatch(saveUser(response.data.user));
      } else {
        store.dispatch(saveUser(response.data));
      }
    }
    return resolve(response);
  })
  .catch((error) => {
    if (error.response && error.response.status && error.response.status === 400) {
      if (error.response && error.response.data && error.response.data.error &&
      error.response.data.error === 'You already have 2 loaded documents') {
        store.dispatch(push(URLS.APPROVED));
        // store.dispatch(push(URLS.SEARCH));
      }
    }

    if (error.response && error.response.status && error.response.status === 401) {
      const adminFilter = new RegExp(/(\/api\/admin)/g);

      setToken();
      setTokenAdmin();
      if (adminFilter.test(error.response.config.url)) {
        store.dispatch(push(URLS.LOGINADMIN));
      } else {
        store.dispatch(logout());
        store.dispatch(push(URLS.LOGIN));
      }
    } else if (
      error.response.config.url &&
      error.response.status &&
      (Object.entries(IGNORE_ERROR_NOTIFY_URL).find((element) => {
        if (element[1] === error.response.config.url && error.response.status === 400) {
          return false;
        }
        return true;
      }))) {
      notify.show(
        error.response && error.response.data && error.response.data.error
          ? error.response.data.error :
          error.response.data.message || 'Something went wrong'
        , 'error', 2000
      );
    }

    return reject(error.response);
  }));

export const signUp = (number, isSignIn) => requestWrapper(axios.post(API[isSignIn ? 'SIGN_IN' : 'SIGN_UP'], {
  telephoneNumber: `${TELEPHONE_CODE}${number}`
}));

export const signUpCode = (body, isSignIn) =>
  requestWrapper(axios.post(API[isSignIn ? 'SIGN_IN_CODE_ACTIVATION' : 'SIGN_UP_CODE_ACTIVATION'], body));


export const sendBirthday = (birthDay, telephoneNumber) =>
  requestWrapper(axios.post(API.BIRTHDAY_ADD, {
    birthDay, telephoneNumber: `${TELEPHONE_CODE}${telephoneNumber}`
  }));

export const sendGender = (gender, telephoneNumber) =>
  requestWrapper(axios.post(API.GENDER, { gender, telephoneNumber: `${TELEPHONE_CODE}${telephoneNumber}` }));

export const sendWorkingStatus = (workingStatus, telephoneNumber) =>
  requestWrapper(axios.post(API.WORKING, { workingStatus, telephoneNumber: `${TELEPHONE_CODE}${telephoneNumber}` }));

export const sendExperienceStatus = (workingExperience, telephoneNumber) =>
  requestWrapper(axios.post(API.EXPERIENCE, { workingExperience, telephoneNumber: `${TELEPHONE_CODE}${telephoneNumber}` }));

export const sendMounthlyStatus = (monthlyIncome, isDownPayment) =>
  requestWrapper(axios.post(API.MOUNTHLY, { monthlyIncome, isDownPayment }));

export const sendDownPayment = minDownPaymentAgreeOrNot =>
  requestWrapper(axios.post(API.DOWNPAYMENTS, { minDownPaymentAgreeOrNot }));

export const sendConfirmation = confirmMonthlyIncome =>
  requestWrapper(axios.post(API.CONFIRMATION, { confirmMonthlyIncome }));

export const sendName = userName => requestWrapper(axios.post(API.NAME, { userName }));

export const facebookAuth = number => requestWrapper(axios.get(`${API.FACEBOOK}/${number}`, {
  headers: { 'X-Requested-With': 'XMLHttpRequest', 'Access-Control-Allow-Origin': '*' }
}));

export const facebookAuthProccess = () => requestWrapper(axios.post(API.FACEBOOK_PROCCESS, {}));

export const sendFile = data => requestWrapper(axios.post(API.FILE_UPLOAD, data, {
  onUploadProgress(progressEvent) {
    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    store.dispatch(progressFile(percentCompleted));
  }
}));

export const fileList = () => requestWrapper(axios.get(API.FILE_LIST));
export const getSearch = () => requestWrapper(axios.get(API.SEARCH));
export const getSearchById = id => requestWrapper(axios.get(`${API.SEARCH}/${id}`));
export const getApproved = () => requestWrapper(axios.get(API.APPROVED));
export const selectCar = carId => requestWrapper(axios.post(API.SELECAR_CAR, { carId }));
export const getSelectedCarById = carId => requestWrapper(axios.get(`${API.SELECAR_CAR}/${carId}`));
export const getSelectedCars = () => requestWrapper(axios.get(`${API.SELECTED_CARS}`));
export const saveDelivery = delivery => requestWrapper(axios.post(`${API.DELIVERY_SET}`, { delivery }));
export const getDelivery = () => requestWrapper(axios.get(`${API.DELIVERY_GET}`));
export const getSignature = id => requestWrapper(axios.get(`${API.SIGNATURE}/${id}`));
export const sendSignature = (name, isEmail) =>
  requestWrapper(axios.post(API.SIGNATURE_SEND, { name, isEmail }));

export const getPayPal = () => requestWrapper(axios.post(API.PAYMENT_PAYPAL));

export const sendNotificationUpload = () => requestWrapper(axios.get(API.UPLOAD_NOTIFICATION));

export const saveEmail = email => requestWrapper(axios.post(API.EMAIL, { email }));

// eslint-disable-next-line
export const sendPayPal = (payment_method_nonce = 'fake-valid-nonce', card) =>
  requestWrapper(axios.post(API.PAYMANT_SEND, { payment_method_nonce, card }));


export const saveUserProgress = (lastRoute, telephoneNumber) =>
  requestWrapper(axios.post(API.USER_PROGRESS, { lastRoute, telephoneNumber }));

export const getUserProgress = () => requestWrapper(axios.get(API.USER_PROGRESS));
export const updateUserSteps = body => requestWrapper(axios.post(API.USER_CAHGE_STEP, body));
export const removeUser = () => requestWrapper(axios.post(API.USER_ROMVE));
export const adminLoginReq = body => requestWrapper(axios.post(API.LOGIN_ADMIN, body));
export const AddAdminUserReq = body => requestWrapper(axios.post(
  API.ADD_ADMIN_USER_REQ,
  body,
  { headers: AdminToken }
));
export const resetAdminPassReq = body => requestWrapper(axios.post(API.RESET_PASS_ADMIN, body));
export const sendNewPassAdmin = body => requestWrapper(axios.post(API.SEND_NEW_PASS_ADMIN, body));

export const checkAuthorization = () => requestWrapper(axios.get(
  API.CHECK_AUTHORIZATION,
  { headers: AdminToken }
));

export const getCarsListAdminEditor = () => requestWrapper(axios.get(
  API.GET_CARS_LIST_EDITOR,
  { headers: AdminToken }
));

export const LogOutAdmin = () => requestWrapper(axios.post(
  API.LOGOUT_ADMIN, {},
  { headers: AdminToken }
));

export const uploadImgCarId = body => requestWrapper(axios.post(
  API.UPLOAD_IMG_CAR, body,
  { headers: AdminToken }
));
export const addNewCar = body => requestWrapper(axios.post(
  API.ADD_NEW_CAR, body,
  { headers: AdminToken }
));
export const editCar = body => requestWrapper(axios.post(
  API.EDIT_CAR, body,
  { headers: AdminToken }
));
export const deleteCar = id => requestWrapper(axios.delete(
  `${API.DELETE_CAR}/${id}`,
  { headers: AdminToken }
));


// set token
(() => {
  const token = localStorage.getItem('carsapp-x-access-token');
  if (token) {
    setToken(token);
  }
})();
(() => {
  const token = localStorage.getItem('carsapp-x-access-token-admin');
  if (token) {
    setTokenAdmin(token);
  }
})();




// WEBPACK FOOTER //
// ./src/api/index.js